import * as React from "react";
import {
  IFormSchemaV2,
  OnMemoryFileRefkeyExchanger,
  OnMemoryMyNumberRefkeyExchanger,
} from "@graffer-inc/form-schema";
import {
  ApplicantSchemaKeys,
  CloudGovFormSchema,
} from "@graffer-inc/cloud-gov-core";
import {
  FormGeneratorV2,
  useFormGenViewModel,
  MarkdownProcessor,
} from "@graffer-inc/form-generator";
import { PreviewFunctionFieldTemplateRegistry } from "../../../../helpers/form-ext/registry/smart-apply-preview-function-field-template-registry";
import { corporationSearchFormBaseUrl } from "../../../../../utils/corporate-search/base-url";
import { addressSearchBaseUrl } from "../../../../../utils/postal-code/base-url";
import { formMarkdownProcessorFactory } from "../../../../../utils/markdown/processor";
import { grafferSchemasSuportTagNames } from "../../../../../utils/markdown/constants";

const processor = formMarkdownProcessorFactory(grafferSchemasSuportTagNames);
const smartApplyGrafferSchemasMarkdownProcessor: MarkdownProcessor = (
  content,
) => {
  return processor.processSync(content).result as React.ReactNode;
};

export const FormPreview: React.FC<{
  currentFormSchema: IFormSchemaV2;
  applicantSchemaKeys: ApplicantSchemaKeys;
}> = ({ currentFormSchema, applicantSchemaKeys }) => {
  const [myNumberRefKeyExchanger] = React.useState(
    new OnMemoryMyNumberRefkeyExchanger(),
  );
  const [fileRefKeyExchanger] = React.useState(
    new OnMemoryFileRefkeyExchanger(),
  );

  const formSubmissionContext = React.useMemo(() => {
    // プレビューの申請基準日は現在時とする。
    return { submissionDate: new Date() };
    // useMemo内部の計算ロジックではcurrentFormSchemaは使用していないが、currentFormSchemaが変更されたらformSubmissionContextも再計算される必要があるのでdependenciesに加えている
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentFormSchema]);

  const cloudGovFormSchema = CloudGovFormSchema.fromJSON(currentFormSchema);
  const formProps = useFormGenViewModel({
    formSchema: cloudGovFormSchema,
    values: CloudGovFormSchema.buildInitialDocument(
      cloudGovFormSchema,
      applicantSchemaKeys,
    ),
    refKeyRegistry: () => ({
      ...myNumberRefKeyExchanger.store,
      ...fileRefKeyExchanger.store,
    }),
    formSubmissionContext,
  });

  const functionFieldTemplateRegistry = React.useMemo(() => {
    return new PreviewFunctionFieldTemplateRegistry(applicantSchemaKeys);
  }, [applicantSchemaKeys]);

  return (
    <FormGeneratorV2
      {...formProps}
      currentSection={undefined}
      refkeyContext={{
        fileRefKeyExchanger,
        myNumberRefKeyExchanger,
      }}
      submissionContext={formSubmissionContext}
      FunctionFieldTemplateRegistry={functionFieldTemplateRegistry}
      externalServiceUrlConfig={{
        corporationSearchFormBaseUrl: corporationSearchFormBaseUrl,
        addressSearchBaseUrl: addressSearchBaseUrl,
      }}
      markdownConfig={{
        markdownProcessor: smartApplyGrafferSchemasMarkdownProcessor,
      }}
    />
  );
};
